import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(

  "inline-flex items-center border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        // Availability pills on venue/space cards.
        available:
          "border-transparent bg-available text-available-foreground shadow-sm",
        limited:
          "border-transparent bg-limited text-limited-foreground shadow-sm",
        // Neutral pill on top of imagery (e.g. "22 seats left").
        surface:
          "border-transparent bg-background text-foreground shadow-sm",
      },
      shape: {
        default: "rounded-md",
        pill: "rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      shape: "default",
    },
  }
)

function Badge({
  className,
  variant,
  shape,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant, shape }), className)} {...props} />);
}

export { Badge, badgeVariants }
